import { useCallback } from 'react';
import { exportModalActions } from '../model/slice/exportModalSlice';
import { getFeatureFlags } from 'app/appState';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { Column, ExportEntity } from '../model/types';

interface OpenExportModalArgs {
  filters: AnyObject;
  columns: Column[];
  entity: ExportEntity;
}

interface HooApi {
  openExportModal: (args: OpenExportModalArgs) => void;
  isExportEnabled: boolean;
}

export const useOpenExportModal = (): HooApi => {
  const dispatch = useAppDispatch();
  const featureFlags = useAppSelector(getFeatureFlags);
  const isExportEnabled = Boolean(featureFlags?.exportData);

  const openExportModal = useCallback(
    ({ filters, columns, entity }: OpenExportModalArgs): void => {
      if (!isExportEnabled) {
        return;
      }

      dispatch(
        exportModalActions.openModal({
          filters,
          columns,
          entity,
        }),
      );
    },
    [dispatch, isExportEnabled],
  );

  return {
    openExportModal,
    isExportEnabled,
  };
};
